var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForlightbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 2500,
    viewBox: "0 0 2500 2500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1375.77 612.761V868.763L1776.33 1098.26V1097.97L1854.69 1143.61V1582.1L1784.08 1541.14L1784 1541.09L1352.96 1294.66L1292.62 1262.66V547.54L1375.77 612.761ZM725.5 830.166V829.932L647.139 875.572V1582.1L725.5 1536.65V1536.46L1087.22 1325.61V1242.63L725.5 1449.5V917.605L1126.07 688.615V1306.79L1209.21 1262.66L1209.18 548.557L725.5 830.166ZM1791.72 1476.01V1176.55L1360.38 929.972V1228.89L1791.72 1476.01Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M688.329 1676.49L1249.37 1952.68L1816.05 1662.78L1249.14 1346.55L688.329 1676.49ZM839.206 1670.88L1248.75 1872.49L1664.03 1660.05L1250.09 1429.15L839.206 1670.88Z",
    fill: "#676DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForlightbg);
export default __webpack_public_path__ + "static/media/for light bg.b3b7217784b2d0554d5b62c6e0e1b220.svg";
export { ForwardRef as ReactComponent };